import { useEffect } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export default function FacebookBlock({ html }) {
  const condition = 'undefined' !== typeof window.FB;

  useEffect(() => {
    if (condition) {
      window.FB.XFBML.parse();
    }
  }, []);

  return parse(DOMPurify.sanitize(html));
}

FacebookBlock.propTypes = {
  html: PropTypes.string,
};

FacebookBlock.defaultProps = {
  html: '',
};
